import AbstractTokenStorage from "./AbstractTokenStorage";
import { DecodedJwt } from "@egis-auth/jwt-utils";

export interface LocalTokenStorageOptions {
  key: string;
}

export default class LocalTokenStorage<
  JwtType extends DecodedJwt = DecodedJwt
> extends AbstractTokenStorage<JwtType> {
  protected options: LocalTokenStorageOptions;

  constructor(options?: LocalTokenStorageOptions) {
    super();
    this.options = {
      key: "userJWT",
      ...options
    };
  }

  public getToken(): JwtType {
    const token = window.localStorage.getItem(this.options.key);
    if (!token)
      throw new Error(
        `No token found in the local storage under key: "${this.options.key}".`
      );

    // Decodes token
    // /!\ Throws
    const decoded = this.decodeJwt(token);

    return decoded;
  }

  public getRawToken(): string {
    const token = window.localStorage.getItem(this.options.key);
    if (!token)
      throw new Error(
        `No token found in the local storage under key: "${this.options.key}".`
      );

    return token;
  }

  public setToken(token: string): void {
    window.localStorage.setItem(this.options.key, token);
  }

  public removeToken(): void {
    window.localStorage.removeItem(this.options.key);
  }
}
